module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_0924_turquoise.55e142e3.jpg";